import layoutAdmin from '@/layouts/layoutAdmin.vue';

const workspace = () => import('@/views/module/lcTracking/LcTrackingWorkspace.vue');
const page = (path, view, title) => ({
  path,
  name: 'lc-tracking-' + view,
  component: workspace,
  meta: { trackingView: view, breadcrumb: [title] },
});

export default [
  {
    path: '/module/lc-tracking',
    alias: '/lc-tracking',
    component: layoutAdmin,
    meta: {
      UserLoggedIn: true,
      modulePrefix: 'lc-tracking',
      lcTracking: true,
      breadcrumb: 'L/C Tracking',
    },
    children: [
      {
        path: '',
        name: 'lc-tracking',
        component: workspace,
        meta: { trackingView: 'dashboard', breadcrumb: ['Dashboard'] },
      },
      page('dashboard', 'dashboard', 'Dashboard'),
      page('cases', 'cases', 'Tracking Cases'),
      page('new', 'new', 'New Tracking Case'),
      page('links', 'links', 'Customer Links'),
      page('reports', 'reports', 'Reports'),
      page('sources', 'sources', 'PI / Indent & L/C'),
      page('cases/:id', 'case', 'Case Details'),
    ],
  },
  {
    path: '/lc-tracking/shared/:token',
    name: 'lc-tracking-customer',
    component: () => import('@/views/module/lcTracking/CustomerTrackingView.vue'),
  },
];
